import React from 'react'
import { twMerge } from 'tailwind-merge'

type ButtonProps = {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'danger' | 'success'
  className?: string
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
  children,
  variant = 'primary',
  className,
  ...props
}: ButtonProps) => {
  const baseStyles =
    'w-full py-2 md:py-4 rounded-full transition-colors font-inter disabled:opacity-30'

  const variants = {
    primary:
      'bg-orange-600 text-white hover:opacity-80',
    secondary:
      'border border-gray-300 text-gray-900 hover:opacity-30 hover:bg-gray-300',
    danger:
      'border border-red-500 text-gray-900 hover:opacity-30 hover:bg-gray-300',
    success:
      'border border-green-500 text-gray-900 hover:opacity-30 hover:bg-gray-300',
  }

  return (
    <button
      className={twMerge(baseStyles, variants[variant], className)}
      {...props}
    >
      {children}
    </button>
  )
}
